import { cloneElement as u } from "react";
import { useMenuButton as f } from "./useMenuButton.js";
import { useMergeRefs as p } from "../../../utils/hooks/useMergeRefs.js";
const P = ({ children: o }) => {
  const { opened: n, ...t } = f(), e = typeof o == "function" ? o({ opened: n }) : o, r = (e.props || {}).ref || null, s = p(t.ref, r);
  return u(e, { ...t, ref: s });
};
export {
  P as MenuButton
};
//# sourceMappingURL=MenuButton.js.map
